import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import defaultRemoveConfirmation from '@wix/da-shared-react/pkg/widgets/defaultRemoveConfirmation';
import GroupAboutBox from './GroupAboutBox';
import EditPopup from './EditPopup';

export const getGroupAboutWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: GroupAboutBox,
  configPopoverComponent: EditPopup,
  confirmRemove: () => defaultRemoveConfirmation({ t, dispatch }),
  widgetCard: {
    minuatureImageSrc:
      'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-22-about-me.svg',
    title: t('widgets.group_about.addButtonHeader'),
    description: t('widgets.group_about.description'),
  },
});
export default getGroupAboutWidgetConfig;
